<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner
    mode="indeterminate"
    color="primary"
  ></mat-progress-spinner>
</div>

<div class="title">
  <h1>Avisos cadastrados</h1>
  <button matButton="filled" (click)="abrirTelaNovoAviso()">
    <span style="margin-right: 6px; font-size: 16px">+</span> Adicionar
  </button>
</div>

<hr class="divider" />

<div class="filters">
  <mat-form-field appearance="outline" class="custom-outline-red">
    <mat-label>Buscar por título</mat-label>
    <img
      matPrefix
      src="../../../../../assets/svg/icons/search.svg"
      alt="Lupa"
      class="search-icon"
    />
    <input
      matInput
      type="text"
      placeholder=" "
      (input)="updateFieldText($event)"
    />
  </mat-form-field>
</div>

<table mat-table [dataSource]="avisos" class="cis-default-table" matSort>
  <ng-container *ngFor="let coluna of colunasTabela" [matColumnDef]="coluna.id">
    <th
      mat-header-cell
      class="header"
      *matHeaderCellDef
      mat-sort-header
      disableClear
    >
      {{coluna.header}}
    </th>
    <td mat-cell *matCellDef="let aviso" (click)="visualizarAviso(aviso.id)">
      <ng-container class="table-line" [ngSwitch]="coluna.propriedade">
        <span *ngSwitchCase="'status'" [ngClass]="getStatusClass(aviso.status)">
          {{ formatarValor(aviso, coluna) }}
        </span>

        <span *ngSwitchCase="'situacao'">
          {{ formatarValor(aviso, coluna) }}

          <ng-container *ngIf="aviso.situacao === 'Entregue'">
            ({{ aviso.totalEntregues }}/{{ aviso.totalVinculados }})
          </ng-container>
        </span>

        <ng-container *ngSwitchDefault>
          {{ formatarValor(aviso, coluna) }}
        </ng-container>
      </ng-container>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns;"
    (click)="abrirDetalhesAviso(row)"
    class="clickable-row"
  ></tr>
</table>

<div class="paginator-container">
  <p>Mostrando {{ inicio }} a {{ fim }} de {{ total }} resultados</p>

  <mat-paginator
    [length]="total"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="false"
    (page)="atualizarContagem($event.pageIndex, $event.pageSize)"
    [selectConfig]="{
      disableOptionCentering: true,
      panelClass: 'custom-paginator-select'
    }"
  >
  </mat-paginator>
</div>
